<template>
  <app-page-subsection v-if="data.length > 0">
    <template #title>
      <span v-html="title" />
    </template>

    <app-carousel :item-gap="8" :item-width="450" :items="data">
      <template #item="{ item }">
        <rating-card :rating="item" />
      </template>
    </app-carousel>
  </app-page-subsection>
</template>

<script lang="ts" setup>
import { useRatingList } from "~/business-areas/rating/composables/rating-list.hook";
import type { TagPageView } from "~/business-areas/tag-page/composables/tag-page-view.hook";

const properties = defineProps<{
  view: TagPageView;
}>();

const title = computed(
  () =>
    `Avis de participants aux sessions - <span class="font-normal">${properties.view.tag.label}</span>`,
);

const { data } = useRatingList({
  tags: [properties.view.tag.path],
  limit: 10,
  has_comment: true,
});
</script>
